var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.7998C20.6655 11.7328 21.3389 11.709 22 11.709C22.9247 11.709 23.8373 11.7866 24.7349 11.8972C27.1758 12.1979 29.0694 14.2286 29.2593 16.6202C29.3909 18.2773 29.5 19.977 29.5 21.709C29.5 23.441 29.3909 25.1407 29.2593 26.7978C29.0694 29.1893 27.1758 31.22 24.7349 31.5208C23.8373 31.6313 22.9247 31.709 22 31.709C21.0752 31.709 20.1626 31.6313 19.265 31.5208C16.8242 31.22 14.9305 29.1893 14.7406 26.7978C14.609 25.1407 14.5 23.441 14.5 21.709C14.5 21.0373 14.5164 20.3704 14.5441 19.709",
    stroke: "url(#paint0_linear_2501_2570)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.709V20.709",
    stroke: "url(#paint1_linear_2501_2570)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.709H29",
    stroke: "url(#paint2_linear_2501_2570)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.209C16.8807 17.209 18 16.0897 18 14.709C18 13.3283 16.8807 12.209 15.5 12.209C14.1193 12.209 13 13.3283 13 14.709C13 16.0897 14.1193 17.209 15.5 17.209Z",
    stroke: "url(#paint3_linear_2501_2570)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_2570",
    x1: 14.5,
    y1: 21.709,
    x2: 29.5,
    y2: 21.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_2570",
    x1: 22,
    y1: 16.209,
    x2: 23,
    y2: 16.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_2570",
    x1: 15,
    y1: 21.209,
    x2: 29,
    y2: 21.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_2570",
    x1: 13,
    y1: 14.709,
    x2: 18,
    y2: 14.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a39b9e90daabe082c024033ccd493436.svg";
export { ForwardRef as ReactComponent };